/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "dropdown-active",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#464646"
            },
            "st1": {
                "fill": "#FFFFFF"
            },
            "st2": {
                "fill": "none",
                "stroke": "#E1E1E1",
                "strokeMiterlimit": "10"
            },
            "dropdownActive": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "61.9",
            "height": "52.6"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", viewBox: "0 0 61.9 52.6", className: "dropdown-active", width: this.props.width, height: this.props.height, style: this.props.dropdownActive },
            _react2["default"].createElement(
                "g",
                { id: "XMLID_2_" },
                _react2["default"].createElement("path", { id: "XMLID_3_", className: "st0", d: "M30.9 13.6l-5.5-5.4.9-.9 4.6 4.5 4.5-4.5.9.9z", style: this.props.st0 })
            ),
            _react2["default"].createElement(
                "g",
                { id: "XMLID_7_" },
                _react2["default"].createElement(
                    "image",
                    { width: "258", height: "219", id: "XMLID_25_", transform: "scale(.24)", overflow: "visible", opacity: ".5" },
                    _react2["default"].createElement(
                        "g",
                        { id: "XMLID_18_" },
                        _react2["default"].createElement("path", { id: "XMLID_24_", className: "st1", d: "M21.4 31.2l9.4-9.5 9.5 9.5", style: this.props.st1 }),
                        _react2["default"].createElement("path", { id: "XMLID_23_", className: "st2", d: "M21.4 31.2l9.4-9.5 9.5 9.5", style: this.props.st2 })
                    )
                )
            )
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/dropdown-active.js